export const marketingConsentServicesFI = [
  'Vakuutus',
  'Luottopisteet',
  'PK-lainat',
  'Vakuudellinen laina',
  'Luottokortti',
  'Talletus',
];
